import React from "react";
import { Link } from "react-router-dom";
import { Calendar, CheckCircle, AlertCircle } from "lucide-react";
import { CANONICAL_APPOINTMENT_TYPE_KEYS } from "./roofingSettingsDefaults";

export const APPOINTMENT_TYPE_LABELS = {
  free_quote_inspection: "Free Inspection",
  phone_video_consult: "Phone / Video Consult",
};

const chipClass =
  "px-2 py-1 rounded text-xs border bg-[#00D1FF]/20 border-[#00D1FF]/50 text-[#00D1FF] cursor-default";

/**
 * Read-only single team calendar row for roofing GHL (calendar_id set via Connect Calendars).
 */
export function RoofingSingleTeamCalendarCard({ calendar }) {
  const row = calendar && typeof calendar === "object" ? calendar : {};
  const staffName =
    String(row.staff_name || row.label || "").trim() || "Main GHL Calendar";
  const calendarId = String(row.calendar_id || "").trim();
  const handles = Array.isArray(row.handles_appointment_types)
    ? row.handles_appointment_types
    : CANONICAL_APPOINTMENT_TYPE_KEYS;
  const connected = Boolean(calendarId);

  return (
    <div
      className="p-4 rounded-xl bg-white/5 border border-white/10 space-y-4"
      data-testid="roofing-single-team-calendar-card"
    >
      <div className="flex items-center gap-2">
        <Calendar className="w-4 h-4 text-[#00D1FF]" />
        <span className="font-mono text-[#00D1FF] text-xs">Team calendar</span>
      </div>

      <div>
        <p className="text-[#9CA3AF] text-xs font-body mb-1">Label</p>
        <p className="text-[#F3F4F6] text-sm font-body">{staffName}</p>
      </div>

      <div>
        <p className="text-[#9CA3AF] text-xs font-body mb-2">Handles appointment types</p>
        <div className="flex flex-wrap gap-2">
          {CANONICAL_APPOINTMENT_TYPE_KEYS.map((key) => (
            <span key={key} className={chipClass}>
              {APPOINTMENT_TYPE_LABELS[key] || key}
            </span>
          ))}
        </div>
        {handles.length !== CANONICAL_APPOINTMENT_TYPE_KEYS.length && (
          <p className="text-amber-400/80 text-xs font-body mt-2">
            Save settings to normalize handles to both visit and call types.
          </p>
        )}
      </div>

      <div>
        <p className="text-[#9CA3AF] text-xs font-body mb-1">GoHighLevel connection</p>
        <div className="flex items-center gap-2">
          {connected ? (
            <>
              <CheckCircle className="w-4 h-4 text-emerald-400 shrink-0" />
              <span className="text-emerald-400/90 text-sm font-body">Connected</span>
            </>
          ) : (
            <>
              <AlertCircle className="w-4 h-4 text-amber-400 shrink-0" />
              <span className="text-amber-400/90 text-sm font-body">Not connected</span>
            </>
          )}
        </div>
        {connected && (
          <p className="text-[#9CA3AF]/80 text-xs font-mono mt-1 break-all">{calendarId}</p>
        )}
      </div>

      <p className="text-[#9CA3AF] text-xs font-body leading-relaxed">
        One GHL calendar handles both site visits and phone consults. Map it under{" "}
        <Link
          to="/dashboard/integrations/crm/ghl"
          className="text-[#00D1FF] hover:underline"
        >
          Integrations → GoHighLevel → Connect Calendars
        </Link>
        .
      </p>
    </div>
  );
}
